import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// import LoadingIndicator from 'components/LoadingIndicator';
import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import Empty from '../Empty';

const styles = {
  done: {
    marginTop: 20,
  },
  empty: {
    minHeight: '60vh',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

const InfiniteScrollApp = ({
  children,
  handleFetchMore,
  isFirstLoad,
  getPage,
  isEmpty,
  emptyText,
  emptyTitle = "There's nothing here yet!",
  doneText,
  doneTitle = "That's everything!",
  doneButtons,
  doneIcon,
  emptyIcon,
  onEmptyClick,
  mt = 0,
}) => {
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    if (getPage === 1) {
      setPage(getPage);
    }
  }, [getPage]);

  useEffect(() => {
    if (!isFirstLoad && page !== 1) {
      const fetchData = () => {
        setLoading(true);
        handleFetchMore(page, setHasMore).finally(() => {
          setLoading(false);
        });
      };
      fetchData();
    }
  }, [page]);

  const handleScroll = () => {
    if (
      !loading
      && !isFirstLoad
      && hasMore
      && !isEmpty
      && window.innerHeight + document.documentElement.scrollTop + 2
        >= document.documentElement.offsetHeight
    ) {
      setPage(prevPage => prevPage + 1);
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  return (
    <Box sx={{ mt, width: '100%', mb: 2 }}>
      {isEmpty && !isFirstLoad ? (
        <Empty
          buttons={
            emptyText && (
              <Button disabled={!onEmptyClick} onClick={onEmptyClick} secondary>
                {emptyText}
              </Button>
            )
          }
          icon={emptyIcon}
          style={styles.empty}
          title={emptyTitle}
        />
      ) : (
        <>
          {!isFirstLoad && children}
          {/* {loading && <LoadingIndicator />} */}
          {!hasMore && (
            <Empty
              buttons={doneButtons}
              icon={doneIcon}
              style={styles.done}
              text={doneText}
              title={doneTitle}
            />
          )}
        </>
      )}
    </Box>
  );
};

InfiniteScrollApp.propTypes = {
  children: PropTypes.node.isRequired,
  handleFetchMore: PropTypes.any.isRequired,
  isFirstLoad: PropTypes.bool.isRequired,
  getPage: PropTypes.number,
  doneButtons: PropTypes.node,
  doneIcon: PropTypes.node,
  doneText: PropTypes.string,
  doneTitle: PropTypes.string,
  isEmpty: PropTypes.bool,
  emptyIcon: PropTypes.node,
  emptyText: PropTypes.string,
  emptyTitle: PropTypes.string,
  onEmptyClick: PropTypes.func,
  mt: PropTypes.number,
};

export default InfiniteScrollApp;
